export * from './view';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/view/index.js
// module id = 765
// module chunks = 2